import { React, useState, useEffect, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import CardProfile from "../../components/Card/CardProfile";
import Map from "../../components/Map";
import CardStatus from "../../components/Card/CardStatus";
import ValueComp from "../Footer/ValueComp";
import hmenu_user from "../../common/images-new/no-profile-pic.png";
import PageWrapper from '../PageWrapper';
import ShowcaseContainer from './ShowcaseContainer';
import ModalCreateShowcase from "../../components/Modal/ModalCreateShowcase";
import ModalAddPost from "../../components/Modal/ModalAddPost";
import Swal from "sweetalert2";

import {
    getShowcases,
    getShowcaseDetails,
    createShowcase,
    addShowcasePost,
    getMyPosts,
    getDPStatistics,
} from "../../redux/actions/showcase";
import Button from "../../components/Button/Button";
import { staticFiles } from "../../components/Helpers/Static";
import { setUserCover, loadVBE, getUserTheme } from "../../redux/actions/auth";
import axios from "axios";
import { apiMainUrl, apiUrl, serverUrl } from "../../components/Helpers/Config";
import { MdDashboard } from 'react-icons/md';
import { tokenAuthorize } from "../../components/Helpers/Common";
import { DPStatistics } from "../../components/DPStatistics";
import { ActiveSpanColor } from "../Theme";

const SHOWCASE_ICON = staticFiles.book;
const DEFAULT_COVER = staticFiles.coverDefault;
const EDIT_LAYOUT_ICON = staticFiles.editLayout;

const Index = () => {

    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()

    const userProfile = useSelector(state => state.auth.user)
    const showcases = useSelector(state => state.showcase.showcases)
    const postValues = useSelector(state => state.showcase.values)
    const myPosts = useSelector(state => state.showcase.myPosts)
    const competency_status = useSelector(state => state.showcase.competency)
    const dpStatistics = useSelector(state => state.showcase.dpStatistics)
    const [aboutPost, setAboutPost] = useState(null)
    const [teachingPhil, setTeachingPhil] = useState(null)
    const [postOptions, setPostOptions] = useState([])
    const [coverImage, setCoverImage] = useState(userProfile?.cover);
    const [coverImageFile, setCoverImageFile] = useState(null);
    const coverImageRef = useRef();

    const [pinnedReflection, setpinnedReflection] = useState("");

    const [buttonDisabled, setButtonDisabled] = useState({
        createAboutShowcase: false,
        createStatusShowcase: false
    })

    useEffect(() => {
        handlePinnedReflection();
        dispatch(getDPStatistics());
        dispatch(getUserTheme());
        localStorage.removeItem("journalSave");
        if (sessionStorage.getItem("profilePath") == "true") {
            const data = sessionStorage.getItem("profileCurrentPath");
            if (data?.includes("/digitalportfolio2")) {
                const path = data?.split("/digitalportfolio2")[1];
                history.push(path);
            } else {
                history.push(sessionStorage.getItem("profileCurrentPath"))
            }
        }
    }, [])

    const handlePinnedReflection = () => {
        return axios.get(
            serverUrl.Pinned_Reflection
        ).then(resp => {
            if (resp.status === 200) {
                setpinnedReflection(resp?.data)
            }

        }).catch((err) => {
            tokenAuthorize(err?.response?.status);
            console.log(err)
        })
    }

    useEffect(() => {
        if (coverImageFile) {
            const objectURL = URL.createObjectURL(coverImageFile);
            setCoverImage(objectURL);
            return () => URL.revokeObjectURL(objectURL);
        }
    }, [coverImageFile]);

    const handleCoverImageChange = (e) => {
        const fileObj = e.target.files[0];
        if (!fileObj) return;
        setCoverImageFile(fileObj);

        const formData = new FormData();
        formData.append('file', fileObj);

        axios.post(apiUrl + 'upload/cover', formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        ).then(resp => {
            if (resp.status === 200) {
                dispatch(setUserCover(apiMainUrl + resp.data.photo))
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            console.log(err)
        });
    }

    useEffect(() => {
        dispatch(getShowcases());
        dispatch(getShowcaseDetails());
        // dispatch(loadVBE());
    }, [dispatch])

    useEffect(() => {
        const scAbout = showcases.filter((scItem) =>
            ((scItem.name.toLowerCase() === 'about me') && scItem.published)
        ).pop()

        const pinnedData = pinnedReflection ? pinnedReflection : 'teaching philosophy';
        const scTeachPhil = showcases.filter((scItem) =>
            ((scItem.name.toLowerCase() === pinnedData?.toLowerCase()) && scItem.published)
        ).pop()

        if (scAbout && scAbout.posts && (scAbout.posts.length > 0)) {
            //PROD Issue
            let sortSCPost = scAbout.posts.sort((a, b) => {
                if (a.order === null) return 1;
                if (b.order === null) return -1;
                return b.order - a.order;
            });
            setAboutPost(sortSCPost[0])
            //setAboutPost(scAbout.posts[0])
        }
        else {
            setAboutPost(null)
        }

        if (scTeachPhil && scTeachPhil.posts && (scTeachPhil.posts.length > 0)) {
            const scTeachPhils = (scTeachPhil.posts).sort(function (a, b) { return b.order - a.order });
            // const scTeachPhils=(scTeachPhil.posts);
            setTeachingPhil(scTeachPhils[0]);
        }
        else setTeachingPhil(null)
    }, [showcases])


    const profile = {
        name: userProfile ? userProfile.fullname : '',
        email: userProfile ?
            (
                (userProfile.display_email && (userProfile.display_email.length > 0)) ? userProfile.display_email
                    : userProfile.email
            )
            : '',
        programme: userProfile ? userProfile.programme : '',
        photo: userProfile ? userProfile.photo : hmenu_user,
        user_type: userProfile ? userProfile.user_type : '',
        program_category: userProfile ? userProfile.programme_category : ''
        // cover: userProfile ? userProfile.cover : ''
    }

    // use for modal create showcase
    const [showCreateShowcase, setShowCreateShowcase] = useState(false)
    const [showcaseName, setShowcaseName] = useState('')
    const [showcaseNameEmpty, setShowcaseNameEmpty] = useState(false)
    const [showcaseNameExist, setShowcaseNameExist] = useState(false)
    const newShowcaseStatus = useSelector(state => state.showcase.new)

    // use for modal create about showcase
    const [showCreateAboutMeShowcase, setShowCreateAboutMeShowcase] = useState(false)
    const [aboutShowcaseExist, setAboutShowcaseExist] = useState(false)
    const openModalAboutShowcase = () => {
        const scAbout = showcases.filter((scItem) => (scItem.name.toLowerCase() === 'about me'))

        if (scAbout.length > 0) {
            Swal.fire({
                heightAuto: false,
                title: 'Showcase Exists',
                html: 'Looks like you already have <b>About Me</b> showcase. Please make sure the showcase is <b>published</b> and add a post to it.',
                icon: 'info'
            });
        }
        else {
            setShowCreateAboutMeShowcase(true)
            setAboutShowcaseExist(false)
            setButtonDisabled({ ...buttonDisabled, createAboutShowcase: false })
        }
    }

    const [showCreateStatusShowcase, setShowCreateStatusShowcase] = useState(false)
    const [statusShowcaseExist, setStatusShowcaseExist] = useState(false)
    const openModalStatusShowcase = () => {
        const pinnedData = pinnedReflection ? pinnedReflection : "teaching philosophy";
        const scTeachPhil = showcases.filter((scItem) => (scItem.name.toLowerCase() === pinnedData?.toLowerCase()))
        if (scTeachPhil.length > 0) {
            Swal.fire({
                heightAuto: false,
                title: 'Showcase Exists',
                html: 'Looks like you already have <b>' + pinnedData + '</b> showcase. Please make sure the showcase is <b>published</b> and add a post to it.',
                icon: 'info'
            });
        }
        else {
            setShowCreateStatusShowcase(true)
            setStatusShowcaseExist(false)
            setButtonDisabled({ ...buttonDisabled, createStatusShowcase: false })
        }
    }

    // use for modal add about post
    const [showAddAboutPost, setShowAddAboutPost] = useState(false)
    const [selectedAboutPost, setSelectedAboutPost] = useState(0)
    const [addAboutPostFailed, setAddAboutPostFailed] = useState(false)

    const openModalAboutPost = () => {
        const scAbout = showcases.filter((scItem) => (scItem.name.toLowerCase() === 'about me'))
        const aboutPostsId = scAbout && scAbout.length > 0 ? scAbout[0].posts.map((post) => (post.id)) : 0
        const aboutPostOptions = myPosts.filter((post) => !aboutPostsId.includes(post.reflection_id))
        if (scAbout.length > 0) {
            setSelectedAboutPost(0)
            setShowAddAboutPost(true)
            dispatch(getMyPosts())
            setPostOptions(aboutPostOptions)
        }
        else {
            Swal.fire({
                heightAuto: false,
                title: 'Cannot add a post',
                html: 'Please create a showcase named <b>About Me</b>',
                icon: 'info'
            });
        }
    }
    //PROD Issue
    const handleAddAboutPost = () => {
        const scAbout = showcases.filter((scItem) => (scItem.name.toLowerCase() === 'about me'))
        if (selectedAboutPost !== 0) {
            dispatch(addShowcasePost(scAbout[0].id, selectedAboutPost, scAbout[0]?.posts?.length)).then(() => {
                dispatch(getShowcases())
            })
        }
    }

    // use for modal add status (teaching philosophy) post
    const [showAddStatusPost, setShowAddStatusPost] = useState(false)
    const [selectedStatusPost, setSelectedStatusPost] = useState(0)
    const [addStatusPostFailed, setAddStatusPostFailed] = useState(false)

    const openModalStatusPost = () => {
        const pinnedData = pinnedReflection ? pinnedReflection?.toLowerCase() : "teaching philosophy"
        const scTeachPhil = showcases.filter((scItem) => (scItem.name.toLowerCase() === pinnedData))
        // const teachPhilPostsId = scTeachPhil && scTeachPhil.length ? scTeachPhil[0].posts.map((post) => (post.id)) : 0
        // const teachPhilPostOptions = teachPhilPostsId != 0 && myPosts?.filter((post) => !teachPhilPostsId?.includes(post?.reflection_id))
        const showcasePostIds = scTeachPhil.map((post) => (post.id))
        const postOptionsData = myPosts.filter((post) => !showcasePostIds.includes(post.reflection_id))

        if (scTeachPhil.length > 0) {
            setSelectedStatusPost(0)
            setShowAddStatusPost(true)
            dispatch(getMyPosts())
            setPostOptions(postOptionsData)
        }
        else {
            let data = pinnedReflection ? pinnedReflection : "Teaching Philosophy"
            Swal.fire({
                heightAuto: false,
                title: 'Cannot add a post',
                // html: 'Please create a showcase named <b>Teaching Philosophy</b>',
                html: 'Please create a showcase named <b>' + data + '</b>',
                icon: 'info'
            });
        }
    }

    const getTabId = (tabName) => {
        const targetShowcase = showcases.filter((scItem) => (scItem.name.toLowerCase() === tabName.toLowerCase()))
        if (targetShowcase.length > 0) {
            return targetShowcase[0].id
        }
        else return 0;
    }
    //PROD Issue
    const handleAddStatusPost = () => {
        const pinnedData = pinnedReflection ? pinnedReflection : 'teaching philosophy';
        const scTeachPhil = showcases.filter((scItem) => (scItem.name.toLowerCase() === pinnedData?.toLowerCase()))
        if (selectedStatusPost !== 0) {
            dispatch(addShowcasePost(scTeachPhil[0].id, selectedStatusPost, scTeachPhil[0]?.posts?.length)).then(() => {
                dispatch(getShowcases())
            })
        }
    }

    const handleNewShowcase = (showcaseName) => {
        setShowcaseNameEmpty(false);
        dispatch(createShowcase(showcaseName, userProfile?.learner_profile_id))
    }

    useEffect(() => {
        if (showCreateShowcase && !newShowcaseStatus.isLoading) {

            if (newShowcaseStatus.isSuccess) {
                setShowCreateShowcase(false)
            }
            else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
                setShowcaseNameEmpty(true);
            }
        }

        if (showCreateAboutMeShowcase && !newShowcaseStatus.isLoading) {

            if (newShowcaseStatus.isSuccess) {
                setShowCreateAboutMeShowcase(false)
            }

        }

        if (showCreateStatusShowcase && !newShowcaseStatus.isLoading) {

            if (newShowcaseStatus.isSuccess) {
                setShowCreateStatusShowcase(false)
            }

        }

        if (showAddAboutPost && !newShowcaseStatus.isLoading) {

            if (newShowcaseStatus.isSuccess) {
                setShowAddAboutPost(false)
                setAddAboutPostFailed(false);
            }
            else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
                setAddAboutPostFailed(true);

            }
        }

        if (showAddStatusPost && !newShowcaseStatus.isLoading) {

            if (newShowcaseStatus.isSuccess) {
                setShowAddStatusPost(false)
                setAddStatusPostFailed(false);
            }
            else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
                setAddStatusPostFailed(true);

            }
        }

        else { }

    }, [newShowcaseStatus])

    return (
        <PageWrapper>
            <div className="h-40 md:h-56 lg:h-68 xl:h-72 w-full object-contain overflow-hidden">
                <input
                    className="hidden"
                    ref={coverImageRef}
                    type="file"
                    accept="image/gif, image/jpeg, image/jpg, image/png"
                    onChange={handleCoverImageChange}
                />
                {(userProfile?.cover != "" && userProfile?.cover != null)
                    ? <img className="w-full h-288px objectfit-cover bgcolor-img" src={userProfile.cover} alt="cover"></img>
                    : <img className="w-full h-288px objectfit-cover bgcolor-img" src={DEFAULT_COVER} alt="cover"></img>
                }
            </div>

            <div className="flex flex-col md:flex-row">
                <div className="flex flex-col items-center mx-5 md:ml-5 xl:ml-24 xl:mr-9">
                    <CardProfile
                        profilePic={profile.photo}
                        username={profile.name}
                        email={profile.email}
                        program={profile.programme}
                        programCategory={profile?.program_category}
                        userType={profile.user_type}
                        aboutMe={aboutPost}
                        openModalPost={openModalAboutPost}
                        openModalShowcase={openModalAboutShowcase}
                    />
                    <ModalCreateShowcase
                        handleClose={() => setShowCreateAboutMeShowcase(false)}
                        show={showCreateAboutMeShowcase}
                        onClick={() => handleNewShowcase("About Me")}
                        showcaseName={"About Me"}
                        showcaseLoader={newShowcaseStatus.isLoading}
                        inputDisabled={true}
                        showcaseNameExist={aboutShowcaseExist}
                        buttonDisabled={buttonDisabled.createAboutShowcase}
                    />
                    <ModalAddPost
                        show={showAddAboutPost}
                        handleClose={() => setShowAddAboutPost(false)}
                        onClick={handleAddAboutPost}
                        dropdownOption={postOptions}
                        value={selectedAboutPost}
                        onChange={(e) => setSelectedAboutPost(e.target.value)}
                        addPostLoader={newShowcaseStatus.isLoading}
                        failed={addAboutPostFailed}
                        tabId={getTabId('about me')}
                    />
                    {/* {userProfile?.role == 'MEMBER' && */}
                    <div className="hidden md:block flex flex-col md:mt-40 lg:mt-5 mb-5">
                        <DPStatistics
                            dataOutStanding={dpStatistics?.outstanding_DP_task_count ? dpStatistics?.outstanding_DP_task_count : "0"}
                            dataShowcase={dpStatistics?.public_showcase_count ? dpStatistics?.public_showcase_count : "0"}
                            dataShared={dpStatistics?.total_shared_count ? dpStatistics?.total_shared_count : "0"}
                        />
                    </div>
                    {/* } */}

                    <div className="hidden md:block flex flex-col lg:mt-5 mb-16">
                        <Map />
                    </div>
                </div>

                <div className="flex flex-1 flex-col md:mx-5 ml-0 xl:mr-24 relative">
                    <div className="hidden md:block flex flex-row absolute top-0 right-0 md:-mt-16" id="hideDropDown">
                        <Button title="EDIT LAYOUT" onClick={() => history.push("/edit-layout", { src: location.pathname, competency_status })}>
                            <MdDashboard className='w-6 h-6' />
                        </Button>
                        {/* <Button title="show about me" onClick={showAboutMe}>
                            <MdDashboard className='text-gray w-6 h-6'/>
                        </Button> */}


                    </div>
                    <div className="">
                        <CardStatus
                            post={teachingPhil}
                            openModalPost={openModalStatusPost}
                            openModalShowcase={openModalStatusShowcase}
                            pinnedReflection={pinnedReflection ? pinnedReflection : "Teaching Philosophy"}
                        />
                        <ModalCreateShowcase
                            handleClose={() => setShowCreateStatusShowcase(false)}
                            show={showCreateStatusShowcase}
                            // onClick={() => handleNewShowcase("Teaching Philosophy")}
                            // showcaseName={"Teaching Philosophy"}
                            onClick={() => handleNewShowcase(pinnedReflection ? pinnedReflection : "Teaching Philosophy")}
                            showcaseName={pinnedReflection ? pinnedReflection : "Teaching Philosophy"}
                            showcaseLoader={newShowcaseStatus.isLoading}
                            inputDisabled={true}
                            showcaseNameExist={statusShowcaseExist}
                            buttonDisabled={buttonDisabled.createStatusShowcase}
                        />
                        <ModalAddPost
                            show={showAddStatusPost}
                            handleClose={() => setShowAddStatusPost(false)}
                            onClick={handleAddStatusPost}
                            dropdownOption={postOptions}
                            value={selectedStatusPost}
                            onChange={(e) => setSelectedStatusPost(e.target.value)}
                            addPostLoader={newShowcaseStatus.isLoading}
                            failed={addStatusPostFailed}
                            tabId={getTabId(pinnedReflection ? pinnedReflection?.toLowerCase() : 'teaching philosophy')}
                        />
                    </div>
                    <ModalCreateShowcase
                        handleClose={() => setShowCreateShowcase(false)}
                        show={showCreateShowcase}
                        onChange={e => setShowcaseName(e.target.value)}
                        onClick={() => handleNewShowcase(showcaseName)}
                        showcaseName={showcaseName}
                        showcaseNameEmpty={showcaseNameEmpty}
                        showcaseNameExist={showcaseNameExist}
                        showcaseLoader={newShowcaseStatus.isLoading}
                    />
                    {(showcases && showcases.length !== 0)
                        ? <ShowcaseContainer
                            profile={profile}
                            data={showcases}
                        />
                        : <div className="flex flex-col space-y-5 justify-center items-center text-gray-400 mt-10 mb-5">
                            <img className="h-80 w-80" src={SHOWCASE_ICON} alt="showcase" />
                            <p className="text-3xl text-center">Welcome to Showcase page!</p>
                            <p className="w-4/6 text-center">Uh oh it’s look like you don’t have anything yet, let’s create a&nbsp;
                                <Link to="/journal/new" className="nav-navigate"><ActiveSpanColor className="hover:underline">new post</ActiveSpanColor></Link> and add them to your&nbsp;
                                <a onClick={() => setShowCreateShowcase(true)} className="cursor-pointer nav-navigate">
                                    <ActiveSpanColor className="hover:underline">showcase</ActiveSpanColor>
                                </a> here
                            </p>
                        </div>
                    }
                    {/* {userProfile?.role == 'MEMBER' && */}
                    <div className="block md:hidden flex flex-col items-center mt-3">
                        <DPStatistics
                            dataOutStanding={dpStatistics?.outstanding_DP_task_count ? dpStatistics?.outstanding_DP_task_count : "0"}
                            dataShowcase={dpStatistics?.public_showcase_count ? dpStatistics?.public_showcase_count : "0"}
                            dataShared={dpStatistics?.total_shared_count ? dpStatistics?.total_shared_count : "0"}
                        />
                    </div>
                    {/* } */}

                    <div className="block md:hidden flex flex-col items-center">
                        <Map />
                    </div>

                </div>

            </div>

            <ValueComp
                data={postValues}
            />

        </PageWrapper>
    )
}

export default Index